import { Link } from 'react-router-dom';
import type { VaultState } from './vaultStore';

/**
 * What every surface shows when the vault would not open.
 *
 * A refused grant is not retryable — the phone has to let this browser back
 * in — so it gets the way to do that instead of a button that fails the same
 * way every time it is pressed.
 */
export function VaultErrorSection({
  state,
  reload,
}: {
  state: Extract<VaultState, { status: 'error' }>;
  reload: () => void;
}) {
  return (
    <section className="placeholder">
      <h1>Could not read the vault</h1>
      <p className="error">{state.message}</p>
      {state.detail && <p className="t-metaMono placeholder-phase">{state.detail}</p>}
      {state.needsRepair ? (
        <p>
          <Link to="/connect">Connect this browser</Link>
        </p>
      ) : (
        <div className="stack">
          <button type="button" onClick={reload}>
            Try again
          </button>
        </div>
      )}
    </section>
  );
}
